<template>
	<div>
		<div class="myChart" id="myChart"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		mounted() {
			this.load();
		},
		methods: {
			drawLine() {
				this.$echarts.registerMap('china', this.config.chinaJson);
				let myChart = this.$echarts.init(document.getElementById('myChart'));
				myChart.setOption({
					title: {
						text: '香港18区人口密度 （2011）',
						subtext: '人口密度数据来自Wikipedia',
						sublink: 'http://zh.wikipedia.org/wiki/%E9%A6%99%E6%B8%AF%E8%A1%8C%E6%94%BF%E5%8D%80%E5%8A%83#cite_note-12'
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}<br/>{c} (p / km2)'
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							dataView: {
								readOnly: false
							},
							restore: {},
							saveAsImage: {}
						}
					},
					visualMap: {
						min: 800,
						max: 50000,
						text: ['High', 'Low'],
						realtime: false,
						calculable: true,
						inRange: {
							color: ['lightskyblue', 'yellow', 'orangered']
						}
					},
					series: [{
						name: '香港18区人口密度',
						type: 'map',
						mapType: 'china', // 自定义扩展图表类型
						label: {
							show: true
						},
						data: [{
								name: '四川',
								value: 20057.34
							}
						],
						// 自定义名称映射
						// nameMap: {
						// 	'Central and Western': '中西区',
						// 	'Eastern': '东区',
						// 	'Islands': '离岛',
						// 	'Kowloon City': '九龙城',
						// 	'Kwai Tsing': '葵青',
						// 	'Kwun Tong': '观塘',
						// 	'North': '北区',
						// 	'Sai Kung': '西贡',
						// 	'Sha Tin': '沙田',
						// 	'Sham Shui Po': '深水埗',
						// 	'Southern': '南区',
						// 	'Tai Po': '大埔',
						// 	'Tsuen Wan': '荃湾',
						// 	'Tuen Mun': '屯门',
						// 	'Wan Chai': '湾仔',
						// 	'Wong Tai Sin': '黄大仙',
						// 	'Yau Tsim Mong': '油尖旺',
						// 	'Yuen Long': '元朗'
						// }
					}]
				});
			},
			load() {
				this.drawLine();
			}
		}
	}
</script>

<style scoped>
	.myChart {
		height: 900px;
		width: 100%;
	}
</style>
